import { createStore } from 'vuex'
import axios from 'axios'
import calendarModule from '@/store/modules/calendar/module'
import tasksListModule from '@/store/modules/tasks-list/module'
import changeEditorModule from '@/store/modules/change-editor/module'
import authModule from '@/store/modules/auth/module'
import statisticsModule from '@/store/modules/statistics/module'
import notificationsModule from '@/store/modules/notifications/module'
import driversModule from '@/store/modules/drivers/module'
import tasksXlsxExportModule from '@/store/modules/tasks-xlsx-export/module'
import automaticLabelsModule from '@/store/modules/automatic-labels/module'
import vehiclesModule from '@/store/modules/web-configuration/vehicles'
import { $axios } from '@/modules/http/axios'
import permissionModule from '@/store/modules/permission/module'

export default createStore({
  modules: {
    tasksList: tasksListModule,
    calendar : calendarModule,
    changeEditor: changeEditorModule,
    statisticsModule: statisticsModule,
    notificationsModule: notificationsModule,
    driversModule: driversModule,
    tasksXlsxExportModule: tasksXlsxExportModule,
    automaticLabelsModule: automaticLabelsModule,
    auth: authModule,
    webConfigVehicles: vehiclesModule,
    permissionModule: permissionModule
  },

  state: {
    lateStoppagesReports: [],
    initialCalendarLoading: true,
    planningTasks: [],
    calendarTrailers: [],
    calendarDrivers: [],
    calendarAutomaticLabels: [],
    calendarCellComments: [],
    calendarMailings: [],
    calendarEditableTask: null,
    calendarEditableDate: null,
    createTaskStepOneData:{},
    isFirstStepDone: false,
    exportMonth:{
      month: '',
      year: ''
    },
    activeDates: []
  },
  getters: {
    getReports (state) {
      return state.lateStoppagesReports
    },

    getInitialCalendarLoading (state) {
      return state.initialCalendarLoading
    },

    getPlanningTasks (state) {
      return state.planningTasks
    },

    getCalendarTrailers (state) {
      return state.calendarTrailers
    },

    getCalendarDrivers (state) {
      return state.calendarDrivers
    },

    getCalendarAutomaticLabels (state) {
      return state.calendarAutomaticLabels
    },

    getCalendarCellComments (state) {
      return state.calendarCellComments
    },

    getCalendarMailings (state) {
      return state.calendarMailings
    },

    getCalendarEditableTask (state) {
      return state.calendarEditableTask
    },

    getCalendarEditableDate (state) {
      return state.calendarEditableDate
    },

    getCreateTaskStepOneData (state){
      return state.createTaskStepOneData
    },

    getIsFirstStepDone (state){
      return state.isFirstStepDone
    },
     getexportMonth (state){
      return state.exportMonth
     },
    getCalendarActiveDates (state) {
      return state.activeDates
    }
  },
  mutations: {
    setReports (state, reports) {
      state.lateStoppagesReports = reports
    },

    setInitialCalendarLoading (state, isInitial) {
      state.initialCalendarLoading = isInitial
    },

    setPlanningTasks (state, tasks) {
      state.planningTasks = tasks
    },

    setPlanningTask (state, task) {
      state.planningTasks.map((taskFromCollection, k) => {
        if (task.id === taskFromCollection.id) {
          state.planningTasks[k] = task
        }
      })
    },

    setCalendarDrivers (state, drivers) {
      state.calendarDrivers = drivers
    },

    setCalendarTrailers (state, trailers) {
      state.calendarTrailers = trailers
    },

    setCalendarAutomaticLabels (state, labels) {
      state.calendarAutomaticLabels = labels
    },

    setCalendarCellComments (state, comments) {
      state.calendarCellComments = comments
    },

    setCalendarMailings (state, mailings) {
      state.calendarMailings = mailings
    },

    setCalendarEditableTask (state, task) {
      state.calendarEditableTask = task
    },

    setCalendarEditableDate (state, date) {
      state.calendarEditableDate = date
    },

    setCreateTaskStepOneData (state, stepOneData){
      state.createTaskStepOneData = stepOneData
    },

    setIsFirstStepDone (state, isFrstStpDone){
      state.isFirstStepDone = isFrstStpDone
    },

    setexportMonth (state, value){
      state.exportMonth.month = value.month
      state.exportMonth.year = value.year
    },

    setCalendarActiveDates (state, activeDates) {
      state.activeDates = activeDates
    }
  },

  actions: {
    updateCalendarEditableTask (context) {
      const axiosConfig = { headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` } }
      axios.get(`${process.env.VUE_APP_API_BASE_URL}Task/${context.state.calendarEditableTask.id}`, axiosConfig).then(response => {
        context.state.calendarEditableTask = response.data
      })
    },

    async fetchTrailers ({ commit }) {
      const trailers = (await $axios.get('Trailer')).data
      commit('setCalendarTrailers', trailers)
    }
  }
})
